import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// recuperation des emplois du temps
export const getAllEdtByYear = async (idYear) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/edt/all/${idYear}`,
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
    },
  );
  return response.data;
};

// recuperation des cours par annee
export const getStudentCourseByYear = async (idClass, id_student) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/course/studentCourseByYear/${idClass}/${id_student}`,
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
    },
  );
  return response.data;
};

// recuperation du cours via son id
export const getCourseByID = async (idCourse) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/course/getById/${idCourse}`,
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
    },
  );
  return response.data;
};

// créer un emplois du temps
export const createEDT = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/edt/create`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// dupliquer un emplois du temps
export const saveAsEDT = async (id, payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/edt/saveAs/${id}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// sauvegarder une version edt sous
export const saveVersionAs = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/coursedt/saveAS`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// modifier un emploie de temps
export const updateEDT = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/edt/update/${id}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// supprimerun emplois du temps
export const deleteEDT = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/edt/delete/${id}`,

    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// Afficher tous les EDT en fonction de l'année académique
export const getAllEDT = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/edt/all/${id_academicYear}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// Récupérer un emploi de temps spécifique
export const getEDTById = async (id, context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/edt/${id}`, {
    headers: setHeaders(context),
  });
  return response.data;
};

// --------------------------------------------------EDT COURS-------------------------------------------------------

// créer les cours d'un emplois du temps
export const createEDTCours = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/coursedt/create`,
    payload,
    {
      headers: setHeaders(context),
    },
  );

  return response.data;
};

// récupérer l'emploi du temps d'une classe par semaine
export const getAllEDTCoursByVersion = async (
  id_versionEDT,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/coursedt/EDTVersion/${id_academicYear}/${id_versionEDT}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const getCoursesForEDTVersion = async (id_versionEDT, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/coursedt/version/${id_versionEDT}/courses`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateCourseForEDTVersion = async (
  id_versionEDT,
  id_course,
  payload,
  context,
) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/coursedt/version/${id_versionEDT}/course/${id_course}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer l'emplois du temps journalierde d'une classe
export const getEDTByClass = async (id_class, id_versionEDT, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/coursedt/classedt/${id_class}/${id_versionEDT}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// récuper l'emplois du temps journalier de toutes les classes
export const getEDTAllClass = async (date, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/coursedt/edtail`,
    date,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// publier/dépublier une version d'un EDT
export const publishEDTVersion = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/coursedt/publish/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// Récupérer les cours réalisés par un professeur
export const getCoursByTeacher = async (id_teacher, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/coursedt/teacher/${id_teacher}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// modifier les cours d'un emplois du temps
export const updateEDTCours = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/coursedt/update/${id}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// Aperçu par classe des emplois du temps
export const getEDTByClassePDF = async (payload, context) => {
  // const { id_class, id_versionEDT } = req.body
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-edt`,
    payload,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};

// récuperer l'emplois du temps par professeur
export const getEDTByTeacherPDF = async (id_academicYear, payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-teacher-edt/${id_academicYear}`,
    payload,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};

// récuperer les enmplois du temps  d'une année pour un prof spécifique
export const getAllPublishedEDTTeacherByYear = async (
  id_academicYear,
  id_teacherProfil,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/coursedt/coursedt/${id_academicYear}/${id_teacherProfil}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// récupérer tous les emplois du temps (EDTVersion) publier
export const getAllEDTVersionPublished = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/coursedt/allpublish/${id_academicYear}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// ------------------Teacher Years Cours----------------------------------------
// récupérer les années ou le profs à des cours
export const getTeacherYearCourse = async (id_teacherProfil, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/coursedt/coursyear/${id_teacherProfil}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// récupérer les années ou le profs à des cours
export const getCurrentYear = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/year/current`, {
    headers: setHeaders(context),
  });
  return response.data;
};
